/**
 * Generate RFC4122v4 compliant UUID
 * Algorithm taken from https://stackoverflow.com/a/2117523
 */
export function generateUUID(): string {;
  return ([1e7].toString() + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (parseInt(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt(c) / 4).toString(16)
  );
}

/**
* Hash a string
* https://stackoverflow.com/a/34842797
* @param str
*/
export function hashStr(str: string) {
  return str.split('').reduce((prevHash, currVal) =>
      (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0);
}

/**
* Merges the URL together with the given query parameters.
* In case of parameter collision, the given query parameters are taken over the base URLs query parameters.
* @param baseUrl base URL, optionally has query parameters
* @param locationUrl location URL, optionally has query parameters and hash
* @return URL string containing merged query parameters and hash (anker)
*/
export function mergeUrlWithQueryParameters(baseUrl: string, locationUrl: string): string {
  const mergedUrl = new URL(baseUrl);
  const referenceUrl = new URL(locationUrl);
  for (const queryParam of referenceUrl.searchParams) {
      mergedUrl.searchParams.set(queryParam[0], queryParam[1]);
  }
  mergedUrl.hash = referenceUrl.hash;
  return mergedUrl.href;
}